import jQuery from 'jquery';
import Flickity from 'flickity';

// Register our jquery version with Flickity.
Flickity.setJQuery(jQuery);

const sliderConfig = {
  arrowShape: 'M13,49.9a5.1,5.1,0,0,1,1.5-3.7L58.4,2.1a5.1,5.1,0,0,1,7.3.9,5.1,5.1,0,0,1,0,6.4L25.5,49.9,65.7,90.3a5.3,5.3,0,0,1-.4,7.4,5.2,5.2,0,0,1-6.9-.1L14.5,53.5A4.8,4.8,0,0,1,13,49.9Z',
  wrapAround: true,
  prevNextButtons: false,
  draggable: false,
  // autoPlay: 3000,
  // pauseAutoPlayOnHover: true,
};

export default class FlickityHomePod {
  constructor(element) {
    this.element = element;
    this.$element = jQuery(element);

    // Exit if we don't have more than one slide.
    if (!this.shouldBuildSlider) return;

    // Build Slider
    this.buildSlider();
    this.ready();
  }

  buildSlider() {
    this.slider = new Flickity(this.sliderElement, sliderConfig);
  }

  ready() {
    this.$element.addClass('ready');
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.view-content');
  }

  get slides() {
    return this.sliderElement.children;
  }
}
